<template>
  <el-dialog
    :visible.sync="isShown"
    title="スタッフログイン">
    <div>
      店長・シフト委員がシフトを修正する画面です。<br>
      パスワードが不明な場合は、サポートセンターに問い合わせてください。<br>
      修正を終えたら、キーボードのF5を押してください。<br>
    </div>
    <el-form v-model="form">
      <el-form-item label="スタッフコード" :error="codeError">
        <el-input v-model="form.code">
        </el-input>
      </el-form-item>
      <el-form-item label="パスワード" :error="passwordError">
        <el-input v-model="form.password" type="password">
        </el-input>
      </el-form-item>
    </el-form>
    <error-list :errors="errors.nonFieldErrors" />
    <div slot="footer">
      <el-button @click="submit" type="primary">ログイン</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {mapActions} from 'vuex'
import ErrorList from '@/parts/ErrorList'

export default {
  name: 'StaffLoginDialog',
  components: {
    ErrorList,
  },
  data () {
    return {
      isShown: false,
      isSending: false,
      form: {
        code: null,
        password: null,
      },
      errors: {
        nonFieldErrors: [],
        code: [],
        password: [],
      },
    }
  },
  computed: {
    passwordError () {
      return this.errors.password.join(', ')
    },
    codeError () {
      return this.errors.code.join(', ')
    },
  },
  methods: {
    ...mapActions(['staffLogin']),
    show () {
      this.isShown = true
    },
    hide () {
      this.isShown = false
      Object.keys(this.form).forEach(key => {
        this.form[key] = null
      })
    },
    submit () {
      if (this.isSending) {
        return
      }
      this.isSending = true
      this.staffLogin([this.form.code, this.form.password]).then((res) => {
        this.$emit('login', res)
        this.hide()
      }, (err) => {
        this.$err400(err, this.errors)
      }).finally(() => {
        this.isSending = false
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Account/StaffLoginDialog.vue